import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-5">
      <div className="w-full max-w-md animate-fadeup">
        <div className="flex flex-col items-center text-center mb-8">
          <img src="/logo.png" alt="Mainan Dede" className="h-20 sm:h-24 w-auto object-contain mb-3" data-testid="login-logo" />
          <p className="label-tag">Manajemen Inventori</p>
        </div>

        <div className="nb-card p-6 sm:p-8">
          <h2 className="text-xl font-display font-bold mb-1">Masuk ke akun</h2>
          <p className="text-sm text-[#52525B] mb-6">Kelola stok barang kamu di sini.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-tag block mb-1.5">Email</label>
              <input data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="nb-input" placeholder="nama@email.com" />
            </div>
            <div>
              <label className="label-tag block mb-1.5">Password</label>
              <input data-testid="login-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="nb-input" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit-button" type="submit" disabled={loading}
              className="nb-btn w-full py-3 flex items-center justify-center gap-2 text-[#0A0A0A]"
              style={{ background: "var(--primary)" }}>
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Masuk"}
            </button>
          </form>
        </div>
        <p className="text-xs text-[#52525B] text-center mt-6">Mainan Dede • bisa dibuka dari HP</p>
      </div>
    </div>
  );
}
